import React, {useContext, useEffect, useRef, useState} from 'react'
import {moneyFormatter, validLimitDecimal} from '../../../../../../utils'
import {AdminProductContext} from '../../../../../context/AdminProductContext'
import {NumericInput} from '../../../../../shared/components/NumericInput'

type Product = {
  data?: any
  currentPage?: number
  totalPages?: number
  handleUpdateProduct: (id: any) => void
  handleSave: () => void
  editingId?: any
  editedData?: any
  handleSaveClick: () => void
  handleInputChange: (e: any) => void
  handlePrevPage: () => void
  handleNextPage: () => void
  handleCancelClick: () => void
  handleCancel: () => void
  handleDeleteProduct: (id: any) => void
  handleChange: (e: any) => void
  handleUpdateSuccess: (e: any) => void
  handleErrorMessage: (msg: string) => void
  isAdding: boolean
  panelTypeRef: any
  thicknessRef: any
  colorRef: any
  coreRef: any
  priceRef: any
  newProduct: any
  handleFilter: (filter1: any, filter2: any, filter3: any, filter4: any, filter5: any) => void
}

function PanelsProduct(props: Product) {
  const {
    data,
    currentPage,
    totalPages,
    handleUpdateProduct,
    handleSave,
    editingId,
    editedData,
    handleSaveClick,
    handleInputChange,
    handlePrevPage,
    handleNextPage,
    handleCancelClick,
    handleCancel,
    handleDeleteProduct,
    handleChange,
    handleUpdateSuccess,
    isAdding,
    panelTypeRef,
    thicknessRef,
    colorRef,
    coreRef,
    priceRef,
    newProduct,
    handleErrorMessage,
    handleFilter,
  } = props
  const [saveData, setSaveData] = useState(isAdding ? newProduct : editedData)

  const {panelBottomColour, panelCores, panelProfiles, panelThickness} =
    useContext(AdminProductContext)

  const [panelProfileFilter, setpanelProfileFilter] = useState('')
  const [panelCoreFilter, setpanelCoreFilter] = useState('')
  const [thicknessFilter, setthicknessFilter] = useState('')
  const [topSheetColourFilter, settopSheetColourFilter] = useState('')
  const [bottomSheetColourFilter, setbottomSheetColourFilter] = useState('')

  useEffect(() => {
    handleFilter(
      panelProfileFilter,
      panelCoreFilter,
      thicknessFilter,
      topSheetColourFilter,
      bottomSheetColourFilter
    )
  }, [
    panelProfileFilter,
    panelCoreFilter,
    thicknessFilter,
    topSheetColourFilter,
    bottomSheetColourFilter,
  ])

  useEffect(() => {
    setSaveData(editedData)
  }, [editedData])

  useEffect(() => {
    setSaveData(newProduct)
  }, [newProduct])

  const numRegex = /^(?:0|[1-9]\d*)(?:\.\d+)?$/

  const invalidRecord =
    (saveData?.panelProfile || '') === '' ||
    (saveData?.panelCore || '') === '' ||
    (saveData?.thickness || '') === '' ||
    (saveData?.topSheetColour || '') === '' ||
    (saveData?.bottomSheetColour || '') === ''

  return (
    <div style={{width: '85%'}} className='m-auto mt-4'>
      <table className='table table-hover product-table'>
        <thead className='thead-dark'>
          <tr>
            <th scope='col' className='align-middle text-center'>
              Item Number
            </th>
            <th scope='col' className='align-middle text-center'>
              Panel Profile
            </th>
            <th scope='col' className='align-middle text-center'>
              Panel Core
            </th>
            <th scope='col' className='align-middle text-center'>
              Thickness
            </th>
            <th scope='col' className='align-middle text-center'>
              Top Sheet Colour
            </th>
            <th scope='col' className='align-middle text-center'>
              Bottom Sheet Colour
            </th>
            <th scope='col' className='align-middle text-center'></th>
          </tr>
          <tr>
            <td className='align-middle text-center'></td>
            <td className='align-middle text-center'>
              <input
                type='text'
                value={panelProfileFilter}
                onChange={(e) => setpanelProfileFilter(e.target.value)}
                className='filter-input'
              />
            </td>
            <td className='align-middle text-center'>
              <input
                type='text'
                value={panelCoreFilter}
                onChange={(e) => setpanelCoreFilter(e.target.value)}
                className='filter-input'
              />
            </td>
            <td className='align-middle text-center'>
              <input
                type='text'
                value={thicknessFilter}
                onChange={(e) => setthicknessFilter(e.target.value)}
                className='filter-input'
              />
            </td>
            <td className='align-middle text-center'>
              <input
                type='text'
                value={topSheetColourFilter}
                onChange={(e) => settopSheetColourFilter(e.target.value)}
                className='filter-input'
              />
            </td>
            <td className='align-middle text-center'>
              <input
                type='text'
                value={bottomSheetColourFilter}
                onChange={(e) => setbottomSheetColourFilter(e.target.value)}
                className='filter-input'
              />
            </td>
            <td className='align-middle text-center'></td>
          </tr>
        </thead>
        <tbody>
          {data?.items?.length === 0 ? (
            <tr>
              <td colSpan={6} className='align-middle text-center'>
                There are no products to display!
              </td>
            </tr>
          ) : (
            data?.items?.map((data: any, index: number) => (
              <tr key={index}>
                <td className='align-middle text-center'>{data?.code}</td>
                <td className='align-middle text-center'>{data?.panelProfileName}</td>
                <td className='align-middle text-center'>{data?.panelCoreName}</td>
                <td className='align-middle text-center'>{data?.panelThicknessName}</td>
                <td className='align-middle text-center'>{data?.panelRoofColourName}</td>
                <td className='align-middle text-center'>{data?.panelBottomColourName}</td>
                <td className='align-middle text-center' style={{width: '250px'}}>
                  <div className='d-flex flex-row justify-content-center align-items-center w-100'>
                    <button
                      className='btn btn-primary btn-sm'
                      onClick={() => handleUpdateProduct(data?.id)}
                      style={{marginRight: 10}}
                    >
                      View
                    </button>
                    <button
                      className='btn btn-danger btn-sm'
                      onClick={() => handleDeleteProduct(data?.id)}
                    >
                      Delete
                    </button>
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      <div className='pagination d-flex align-items-center pb-4'>
        <button className='page-link' onClick={handlePrevPage} disabled={currentPage === 1}>
          <i className='bi bi-chevron-left'></i>
        </button>
        <div className='px-4'>{`Page ${currentPage} of ${totalPages}`}</div>
        <button
          className='page-link'
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
        >
          <i className='bi bi-chevron-right'></i>
        </button>
      </div>
    </div>
  )
}

export default PanelsProduct
